import { pushPlayerAction } from './actionlog.service';
import { api } from './api';

export async function getNews(cad_missao: number, date?: any) {
  const payload = [
    {
      $match: {
        $or: [
          {
            cad_missao: cad_missao?.toString(),
          },
          {
            cad_missao: {
              $exists: false,
            },
          },
        ],
      },
    },
    { $sort: { created: -1 } },
    { $limit: 1 },
  ] as any;

  if (date) {
    payload.unshift({
      $match: {
        created: {
          $gt: {
            $date: date,
          },
        },
      },
    });
  }

  const { data } = await api.post(`find/get_news`, { date });
  if (!Array.isArray(data)) {
    return null;
  } else {
    return data[0];
  }
}

export async function getNewsLog() {
  const { data } = await api.post(`find/news_log`, {});
  if (!Array.isArray(data)) {
    return null;
  } else {
    return data[0];
  }
}

export async function updateNewLog(user: string, time: number) {
  const payload = {
    _id: user,
    time: {
      $date: time,
    },
  };

  pushPlayerAction('updateNewLog', {
    endpoint: `database/news_log__c`,
    data: payload,
    method: 'PUT',
  });

  const { data } = await api.put(`database/news_log__c`, payload);
  if (!Array.isArray(data)) {
    return null;
  } else {
    return data[0];
  }
}
